import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function ViewSettings (){
  const {user} = useUser()
  let view = contentLayout[modules.Settings]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.Settings.toLowerCase())){
     view = Forbidden 
  }
  return(
  <Index content={view} module={modules.Settings}></Index>
 )
}

export default ViewSettings
